import { ROUTES } from './default/routes.ts';
import type { LinkDefinition } from './mainNavigationLinks.types.ts';

const SAFER_GAMBLING_LINK_DEFINITION: LinkDefinition = {
  href: ROUTES.MY_ACCOUNT.SAFER_GAMBLING,
  labelKey: 'safer_gambling',
  trackName: 'Safer Gambling',
  trackContainer: 'Safer Gambling',
  testId: 'my-account-safer-gambling',
};

const SETTINGS_LINK_DEFINITION: LinkDefinition = {
  href: ROUTES.MY_ACCOUNT.SETTINGS(),
  labelKey: 'settings',
  trackName: 'Settings',
  trackContainer: 'Settings',
  testId: 'my-account-settings',
};

export { SAFER_GAMBLING_LINK_DEFINITION, SETTINGS_LINK_DEFINITION };
